import React, { PureComponent } from "react";
import { message } from "antd";
import { downloadImg } from "@/utils/constant";
import VoltageGauge from "./components/VoltageGauge"
import Temperature from "./components/Temperature"
import CurrentGauge from "./components/CurrentGauge"
import LiquidFill from "./components/LiquidFill";
import PropIcon from "@/components/Icon/PropIcon";
import http from "@/http";
import img1 from "./components/img/信号-优.png"
import img2 from "./components/img/信号-良好.png"
import img3 from "./components/img/信号-一般.png"
import img4 from "./components/img/信号-弱.png"
import img5 from "./components/img/信号-无.png"
import img7 from "./components/img/市电供电.png"
import img8 from "./components/img/电池供电.png"
import img9 from "./components/img/蜂鸣器.png"
import img10 from "./components/img/蜂鸣器-静音.png"
import styles from "./status.module.less"

const titleStyle = {
    backgroundColor: 'rgb(24,144,255)',
    borderBottomRightRadius: '1rem', borderTopRightRadius: '1rem',
    fontSize: '0.18rem', marginTop: '0.08rem', marginBottom: '0.08rem',
    height: '0.3rem', width: '1rem', textAlign: 'center',
    color: `#FFF`,
}
const rsrpLevel = ['无信号', '信号弱', '一般', '良好', '优']
const rsrpLevelImg = [img5, img4, img3, img2, img1]

class StatusTab extends PureComponent {

    sendSync = () => {
        const { actionMap } = this.props
        const action = (actionMap || {}).Sync
        const { id, code } = action || {}
        this.sendAction(id, code, {})
    }
    sendResetAlarm = () => {
        const { actionMap } = this.props
        const action = (actionMap || {}).ResetAlarm
        const { id, code } = action || {}
        this.sendAction(id, code, {})
    }
    sendMute = () => {
        const { actionMap } = this.props
        const action = (actionMap || {}).Mute
        const { id, code } = action || {}
        this.sendAction(id, code, { buzzerStatus: false })
    }
    sendCtrlOutput = () => {
        const { actionMap } = this.props
        const action = (actionMap || {}).CtrlOutput
        const { id, code } = action || {}
        this.sendAction(id, code, { output: 1, sw: true })
    }
    sendAction = (actionId, actionCode, params) => {
        const { detail } = this.props;
        const { id } = detail || {};
        params.actionId = actionId;
        params.actionCode = actionCode;
        const data = {
            deviceId: id,
            actionId, params
        };
        actionId && id && http.tokiot.device.action(data)
            .then(ret => ret && message.success('操作成功'))
    }

    render() {
        const { fieldMap, detail, status, actionMap, onActionSubmit, loadDefaultValue } = this.props
        const buzzerEn = status.buzzerEn || {}
        const powerStatus = status.powerStatus || {}
        const rssi = status.rssi || {}

        const actionProps = {
            defaultValue: status,
            loadDefaultValue,
            deviceId: detail.id,
            onActionSubmit
        }

        return <React.Fragment>
            <div style={{ ...titleStyle, backgroundColor: 'rgb(24,144,255)' }}>设备信息</div>
            <div className={styles.deviceInfo}>
                {deviceInfoItem({
                    opacity: 0.4,
                    img: rsrpLevelImg[formatRsrp(rssi.defValue)],
                    lable: rsrpLevel[formatRsrp(rssi.defValue)]
                })}
                {deviceInfoItem({
                    img: buzzerEn.defValue ? img9 : img10,
                    lable: (buzzerEn.defValue ? '开' : '关')
                })}
                {deviceInfoItem({
                    opacity: 0.4,
                    img: 1 == powerStatus.defValue ? img7 : img8,
                    lable: 1 == powerStatus.defValue ? '市电' : '电池'
                })}
            </div>
            <div style={{ ...titleStyle, backgroundColor: 'rgb(224,98,13)' }}>剩余电流</div>
            <div style={{ display: 'flex', flexWrap: 'wrap', height: 'auto', marginTop: '0.2rem' }}>
                <div style={{ width: '100%', height: '100%', position: 'relative' }}>
                    <LiquidFill data={fieldMap.leakage} filed=''
                        action={actionMap.SetLeakage}   {...actionProps} />
                </div>
            </div>
            <div style={{ ...titleStyle, backgroundColor: 'rgb(224,98,13)' }}>电流监控</div>
            <div style={{ display: 'flex', flexWrap: 'wrap', height: '2.25rem' }}>
                <div style={{ width: '33%', height: '100%' }}>
                    <CurrentGauge data={fieldMap.currentA} filed='A相' action={actionMap.SetCurrentA}  {...actionProps} />
                </div>
                <div style={{ width: '33%', height: '100%' }}>
                    <CurrentGauge data={fieldMap.currentB} filed='B相' action={actionMap.SetCurrentB}{...actionProps} />
                </div>
                <div style={{ width: '33%', height: '100%' }}>
                    <CurrentGauge data={fieldMap.currentC} filed='C相' action={actionMap.SetCurrentC} {...actionProps} />
                </div>
            </div>
            <div style={{ ...titleStyle, backgroundColor: 'rgb(224,98,13)' }}>电压监控</div>
            <div style={{ display: 'flex', flexWrap: 'wrap', height: '2.25rem' }}>
                <div style={{ width: '33%', height: '100%' }}>
                    <VoltageGauge data={fieldMap.voltageA} filed='A相' action={actionMap.SetVoltageA} {...actionProps} />
                </div>
                <div style={{ width: '33%', height: '100%' }}>
                    <VoltageGauge data={fieldMap.voltageB} filed='B相' action={actionMap.SetVoltageB} {...actionProps} />
                </div>
                <div style={{ width: '33%', height: '100%' }}>
                    <VoltageGauge data={fieldMap.voltageC} filed='C相' action={actionMap.SetVoltageC} {...actionProps} />
                </div>
            </div>
            <div style={{ ...titleStyle, backgroundColor: 'rgb(224,98,13)' }}>温度监控</div>
            <div style={{ display: 'flex', flexWrap: 'wrap', height: '2rem', width: '100%' }}>
                <div style={{ height: '100%', width: '25%' }}>
                    <Temperature data={fieldMap.temp1} filed='A相' bgColor='rgb(236,128,141)'
                        action={actionMap.SetTemp1MaxThr}  {...actionProps} /></div>
                <div style={{ height: '100%', width: '25%' }}>
                    <Temperature data={fieldMap.temp2} filed='B相' bgColor='rgb(236,128,141)'
                        action={actionMap.SetTemp2MaxThr}  {...actionProps} /></div>
                <div style={{ height: '100%', width: '25%' }}>
                    <Temperature data={fieldMap.temp3} filed='C相' bgColor='rgb(236,128,141)'
                        action={actionMap.SetTemp3MaxThr}  {...actionProps} /></div>
                <div style={{ height: '100%', width: '25%' }}>
                    <Temperature data={fieldMap.temp4} filed='零线' bgColor='rgb(236,128,141)'
                        action={actionMap.SetTemp4MaxThr}  {...actionProps} /></div>

            </div>
        </React.Fragment>
    }

}

export default StatusTab


const renderFromItem = ({ label, item, hasUnit, extra, render }) => {
    return <div>
        <span style={{ display: 'inline-block', marginLeft: '0.2rem', minWidth: '1.1rem' }}>
            <PropIcon type={(item || {}).icon || "prop-liangdu"}
                style={{ color: 'rgb(24,144,255)' }} />&nbsp;&nbsp;{label}&nbsp;:</span>
        <span style={{
            display: 'inline-block',
            marginLeft: '0.08rem',
            maxWidth: '2.8rem'
        }}>{render ? render(item || {}) : (item || {}).value}&nbsp;{hasUnit ? (item || {}).unit : ''}&nbsp;{extra}</span>
    </div>
}

function deviceInfoItem({ img, lable, opacity = 1, }) {
    return (
        <div className={styles.imageMain} style={{ opacity }} >
            <div className={styles.imageDiv} >
                <img src={img} className={styles.image} />
            </div>
            <div className={styles.text}>{lable}</div>
        </div>
    )
}

function formatRsrp(rsrp) {
    if (0 < rsrp && rsrp <= 9) return 2;
    else if (9 < rsrp && rsrp <= 19) return 3;
    else if (19 < rsrp) return 4;
    else return 0;
}